<template>
  <div class="main-content fasilitas asuransi">
    <section class="inner-header about-us">
      <div class="container pt-60 pb-70">
        <!-- Section Content -->
        <div class="section-content">
          <div class="row">
            <div class="col-md-12">
              <h2 class="title">Partner Asuransi</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="fasilitas-containter about-detail-container">
      <div class="container">
        <!-- <div class="row">
          <div class="col-md-5">
            <img src="http://placehold.it/550x420" alt class="img-about" />
          </div>
          <div class="col-md-7 mt-xs-30">
            <h2 class="mt-0">
              Apakah anda berobat di
              <span class="text-theme-colored">Rumah Sakit UII</span> memiliki asuransi?
            </h2>
          </div>
        </div>-->

        <div class="section-title text-center poliklinik mt-50">
          <div class="row">
            <div class="col-md-12">
              <h2 class="text-uppercase mt-0 line-height-1">
                Partner Asuransi
                <span class="text-theme-colored">Rumah Sakit UII</span>
              </h2>
            </div>
          </div>
        </div>
        <div class="section-content mt-30">
          <i v-if="show_loading" class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
          <div v-else-if="assurances.length < 1" class="alert alert-danger">No data</div>
          <div v-else class="row asuransi-rows">
            <div
              :key="'assurance-single-' + item.id"
              v-for="item in assurances"
              class="col-xs-12 col-sm-6 col-md-6 col-lg-3 mb-30 asuransi-list"
            >
              <img
                v-bind:src="(JSON.parse(item.meta).meta_picture == null) ? 'http://placehold.it/200x200' : JSON.parse(item.meta).meta_picture"
                alt
                class="img-responsive"
              />
              <router-link :to="{ path: '/asuransi/'+item.id }">
                <h5 class="mt-15 mb-10 text-center">{{ item.title }}</h5>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import api from "../services/api";

export default {
  data() {
    return {
      show_loading: true,
      assurances: [],
    };
  },
  mounted() {
    this.getAssurance();
  },
  methods: {
    getAssurance() {
      this.show_loading = true;
      api
        .post(api.route.get.assurance)
        .then((res) => {
          let status = res.status;
          if (status) this.assurances = res.data;
          this.show_loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.show_loading = false;
        });
    },
  },
  computed: {},
};
</script>


// WEBPACK FOOTER //
// src/pages/Asuransi.vue